import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "services/baseQuery";
import {
  createTicketPayload,
  GetAllTicketPayload,
  ticketMessagePayload,
} from "type/ticket";

export const ticket = createApi({
  reducerPath: "ticket",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getAllTicket: builder.mutation<any, GetAllTicketPayload>({
      query: ({ body, page, search }) => ({
        url: `tickets?page=${page}&search=${search}`,
        method: "POST",
        body,
      }),
    }),
    getTicketStats: builder.mutation<any, any>({
      query: ({ body, search }) => ({
        url: `ticket/statsWithDateRange?search=${search}`,
        method: "POST",
        body,
      }),
    }),
    getTicketSubjects: builder.query<any, void>({
      query: () => ({
        url: `ticket/subjects`,
        method: "GET",
      }),
    }),
    getTicketMessage: builder.query<any, { id: string; page: number }>({
      query: ({ id, page }) => ({
        url: `ticket/${id}/messages?page=${page}`,
        method: "GET",
      }),
    }),
    getSingleTicket: builder.query<any, string>({
      query: (id) => ({
        url: `tickets/${id}`,
        method: "GET",
      }),
    }),
    createTicket: builder.mutation<any, createTicketPayload>({
      query: (body) => ({
        url: `ticket`,
        method: "POST",
        body,
      }),
    }),
    closeTicket: builder.mutation<any, string>({
      query: (id) => ({
        url: `ticket/${id}/close`,
        method: "POST",
      }),
    }),
    reOpenTicket: builder.mutation<any, string>({
      query: (id) => ({
        url: `ticket/${id}/re-open`,
        method: "POST",
      }),
    }),
    addTicketMessage: builder.mutation<any, ticketMessagePayload>({
      query: (body) => ({
        url: `ticket/addMessage`,
        method: "POST",
        body,
      }),
    }),
    updateTicket: builder.mutation<any, { id: any; body: any }>({
      query: ({ id, body }) => ({
        url: `ticket/${id}/close`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllTicketMutation,
  useCreateTicketMutation,
  useGetSingleTicketQuery,
  useGetTicketSubjectsQuery,
  useGetTicketMessageQuery,
  useAddTicketMessageMutation,
  useCloseTicketMutation,
  useReOpenTicketMutation,
  useGetTicketStatsMutation,
} = ticket;
